// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__QZaRR","error":"Textarea_error__2ghii","readonly":"Textarea_readonly__3PZBK","disabled":"Textarea_disabled__2VzXm"};